import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import filterdetailsmiscellaneous from '@/views/private/miscellaneousreimbursement/components/tablelotspaid/components/filterdetailsmiscellaneous.vue'
import Tools from '@/components/tools/Tools.js'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin.js'
import MiscellaneousExpensesRepository from '@/shared/http/repositories/business/miscellaneousexpenses'
const name = 'TableBoardPaidDirectory'

export default {
  name,
  mixins: [ActionsForm, ExpenseMixin],
  components: {
    AutocompleteZ,
    HeadDetailsGama,
    filterdetailsmiscellaneous
  },

  props: { },

  updated () { },

  data () {
    return {
      loteid: null,
      ArrayLotePagosDetalhes: [],
      dataSearch: {},
      infoDetalhes: {},
      LotesEmployee: [],
      modalDetalhes: {},
      funcionarioIdDetalhes: null,
      dataInicio: null,
      dataFinal: null,
      SomaDespesa: 0,
      SomaDespesaLote: 0,
      LotesPagosDetalhes: [],
      definitivo: false,
      motivo: null
    }
  },
  mounted () {
    // this.onLoad()
  },

  methods: {
    onLoad () {
      let param = new URLSearchParams(window.location.search)
      this.loteid = param.get('lote')
      this.getDetailsbyIds(this.loteid)
    },
    getDetailsbyIds (loteid) {
      loading.push()
      this.dataSearch.EmpresaId = this.CompanySelected
      MiscellaneousExpensesRepository.GetLotesDiretoriaDetalhes(loteid, this.$refs.tableGridLoteDiretoria.pagingLimit, this.$refs.tableGridLoteDiretoria.pagingIndex, this.dataSearch)
        .then((Response) => {
          loading.pop()
          this.$refs.tableGridLoteDiretoria.LoadAllByData(Response)
          this.ArrayLotePagosDetalhes = Response.data.data
          this.LotesPagosDetalhes = this.ArrayLotePagosDetalhes
        })
        .catch((Error) => {
          loading.pop()
          toast.error('error!')
        })
    },
    search (data) {
      this.dataSearch = data
      this.onLoad()
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    formataData (value) {
      if (value !== 'N/D') {
        var data = new Date(value)
        var dia = data.getDate()
        var mes = data.getMonth() + 1
        var ano = data.getFullYear()
        var dataFormatada = dia.toString().padStart(2, '0') + '/' + mes.toString().padStart(2, '0') + '/' + ano
        return dataFormatada
      } else {
        return 'N/D'
      }
    },
    ModalPopup (event) {
      this.loteid = event.id
      this.funcionarioIdDetalhes = event.funcionarioId
      this.$refs['popupExpenseDiretoria'].show()
      this.modalInfo(event)
    },
    modalInfo (event) {
      if (event != null && event !== undefined) {
        this.infoDetalhes = event
      }
      MiscellaneousExpensesRepository.GetExpensesModalByLotes(this.infoDetalhes.id, this.infoDetalhes.funcionarioId, this.CompanySelected)
        .then((Response) => {
          this.loteid = this.infoDetalhes.id
          this.funcionarioIdDetalhes = this.infoDetalhes.funcionarioId
          this.getLotes()
          this.modalDetalhes = Response.data[0]
        })
    },
    getLotes () {
      MiscellaneousExpensesRepository.GetExpensesByLotes(this.loteid, this.funcionarioIdDetalhes, this.CompanySelected, this.$refs.tableGridLotePagoDetalhesModalDiversos.pagingLimit, this.$refs.tableGridLotePagoDetalhesModalDiversos.pagingIndex)
        .then((Response) => {
          this.funcionarioIdDetalhes = null
          this.$refs.tableGridLotePagoDetalhesModalDiversos.LoadAllByData(Response)
          this.LotesEmployee = Response.data.data
          this.getTotalLotes(this.LotesEmployee)
        })
    },
    getTotalLotes (event) {
      this.SomaDespesa = event.map(Element => {
        return Element.total
      })
      const soma = this.SomaDespesa.reduce((acumulador, valorAtual) => {
        return acumulador + valorAtual
      }, 0)
      this.SomaDespesaLote = soma
    },
    back () {
      this.$router.push({ name: 'prestacaoconta' })
    },
    apprLoteBoard (loteid) {
      loading.push()
      MiscellaneousExpensesRepository.apprLoteBoard(loteid)
        .then((Response) => {
          loading.pop()
          this.onLoad()
          toast.success('Lote Aprovado com sucesso')
        })
        .catch((Error) => {
          loading.pop()
          toast.error('Erro')
        })
    },
    RepLoteBoard (loteid) {
      loading.push()
      MiscellaneousExpensesRepository.RepLoteBoard(loteid, {motivoRecusa: this.motivo, ReprovacaoDefinitiva: this.definitivo})
        .then((Response) => {
          loading.pop()
          this.motivo = null
          this.definitivo = null
          this.$refs['devolver-despesa'].hide()
          this.$refs['modal-EscolhaReprova'].hide()
          this.getDetailsbyIds(loteid)
          this.definitivo ? toast.success('Reprovação realizado com sucesso') : toast.success('Devolução realizado com sucesso')
          this.onLoad()
        })
        .catch((Error) => {
          loading.pop()
          toast.error('Erro')
        })
    },
    openPopupReprove (loteid) {
      this.$refs['modal-EscolhaReprova'].show()
    },
    modalDevolucao () {
      this.definitivo = false
      this.$refs['devolver-despesa'].show(this.loteid)
    },
    modalDefinitivo () {
      this.definitivo = true
      this.$refs['devolver-despesa'].show(this.loteid)
    },
    backModal () {
      this.motivo = null
      this.$refs['devolver-despesa'].hide()
      this.$refs['modal-EscolhaReprova'].show(this.loteid)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/miscellaneousreimbursement/components/tableboard/components/tableboardpaiddirectory.js